import React, { useEffect } from 'react'
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';
import { Position } from 'reactflow';
import CustomHandle from '../../WorkFlow/Nodes/CustomHandle';

const handleStyle = { backgroundColor: colors.primary03, height: 8, width: 8, borderRadius: 4 };

const WriteEmailNode = ({ data, isConnectable, selected }) => {

    return (
        <>
            <div className='Row justify-content-center' style={{
                border: selected ? `2px solid ${colors.primary03}` : `1px solid ${colors.borderwhite}`,
                borderRadius: 16,
                backgroundColor: colors.white01,
                paddingBlock: 16,
                paddingInline: 20,
                width: 250,
            }}>
                <CustomHandle type='target' position={Position.Top} isConnectable={1} />
                <CustomHandle type='source' position={Position.Bottom} isConnectable={1} />
                <img
                    src={images.SeqWENode}
                    style={{
                        height: 32, width: 32, objectFit: 'contain'
                    }}
                />
                <p style={{ fontSize: 16, fontWeight: 600, marginInline: 16 }}>
                    {'Email follow up'}
                </p>
                {/* <img 
            src={images.SeqThreeDots} 
            style={{
                height:24,width:24,objectFit:'contain',cursor:'pointer'
            }}
        /> */}
            </div>
        </>
    )
}

export default WriteEmailNode